// appApi.ts
import { baseApi } from '@services';
import { AppsResponse, GetAppsArgs } from '../types';

const extendedApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getApps: builder.query<AppsResponse, GetAppsArgs>({
            query: (/* args */) => ({
                headers: {},

                url: '', //apiPaths.app,
            }),
            //          transformResponse: (rawResponse: AppsResponse): appItem[] => {
            //              return rawResponse.items.map(item => ({}));
            //          },
            //          providesTags: (result) => result ? [...result.map(({ id }) => ({ type: 'App', id})), {type: 'App', id: 'LIST' }] : [{ type: 'App', id: 'LIST' }],
        }),
    }),
});

export const { useGetAppsQuery, useLazyGetAppsQuery } = extendedApi;

export default extendedApi.endpoints;
